import { Link } from 'react-router-dom';
import { User } from '../../../types/auth';

type HomePageProps = {
  user: User;
};

export default function HomePage({ user }: HomePageProps) {
  return (
    <section className="card content-card">
      <h2>Bienvenido</h2>
      <p className="subtitle">
        Hola {user.name}, desde aqui podras administrar medicinas y usuarios.
      </p>
      <div className="grid">
        <article className="module-card">
          <h3>Modulo de Medicinas</h3>
          <p>CRUD de productos, control de stock y precios.</p>
          <Link to="/admin/medicinas" className="button-link">
            Ir al modulo
          </Link>
        </article>
        <article className="module-card">
          <h3>Modulo de Ordenes</h3>
          <p>Pedidos con lineas de medicinas y datos del cliente.</p>
          <Link to="/admin/ordenes" className="button-link">
            Ir al modulo
          </Link>
        </article>
        <article className="module-card">
          <h3>Gestion de Usuarios</h3>
          <p>Administracion de roles, acceso y estado de cuentas.</p>
          <Link to="/admin/usuarios" className="button-link">
            Ir al modulo
          </Link>
        </article>
      </div>
    </section>
  );
}
